module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "Basic-Text-Frame"
  }, [_c('p', {
    staticClass: "toc",
    attrs: {
      "id": "_idParaDest-2"
    }
  }, [_vm._v("Table of"), _c('span', {
    staticClass: "noBreak"
  }), _vm._v("Contents")]), _vm._v(" "), _c('p', {
    staticClass: "link"
  }, [_c('a', {
    attrs: {
      "href": "#/TheBestNewTrueCrimeStories6#_idTextAnchor035"
    }
  }, [_vm._v("Introduction")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor000"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/TheBestNewTrueCrimeStories6#_idTextAnchor036"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link1"
  }, [_c('a', {
    attrs: {
      "href": "#/TheBestNewTrueCrimeStories6#_idTextAnchor036"
    }
  }, [_vm._v("Mitzi Szereto")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor001"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/TheBestNewTrueCrimeStories7#_idTextAnchor038"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link"
  }, [_c('a', {
    attrs: {
      "href": "#/TheBestNewTrueCrimeStories7#_idTextAnchor038"
    }
  }, [_vm._v("Twenty-Five Years Later, This AT Lesbian "), _c('br'), _vm._v("Double Murder Still Haunts Me")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor002"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/TheBestNewTrueCrimeStories7#_idTextAnchor040"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link1"
  }, [_c('a', {
    attrs: {
      "href": "#/TheBestNewTrueCrimeStories7#_idTextAnchor040"
    }
  }, [_vm._v("Lindsey Danis")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor003"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/TheBestNewTrueCrimeStories8#_idTextAnchor042"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link"
  }, [_c('a', {
    attrs: {
      "href": "#/TheBestNewTrueCrimeStories8#_idTextAnchor042"
    }
  }, [_vm._v("The Great Montréal Museum Heist Of 1972")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor004"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/TheBestNewTrueCrimeStories8#_idTextAnchor044"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link1"
  }, [_c('a', {
    attrs: {
      "href": "#/TheBestNewTrueCrimeStories8#_idTextAnchor044"
    }
  }, [_vm._v("Anya Wassenberg")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor005"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/TheBestNewTrueCrimeStories9#_idTextAnchor046"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link"
  }, [_c('a', {
    attrs: {
      "href": "#/TheBestNewTrueCrimeStories9#_idTextAnchor046"
    }
  }, [_vm._v("The Lady Vanishes: The Mysterious Disappearance of "), _c('br'), _vm._v("Jean Spangler")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor006"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/TheBestNewTrueCrimeStories9#_idTextAnchor048"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link1"
  }, [_c('a', {
    attrs: {
      "href": "#/TheBestNewTrueCrimeStories9#_idTextAnchor048"
    }
  }, [_vm._v("Joan Renner")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor007"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/TheBestNewTrueCrimeStories10#_idTextAnchor050"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link"
  }, [_c('a', {
    attrs: {
      "href": "#/TheBestNewTrueCrimeStories10#_idTextAnchor050"
    }
  }, [_vm._v("Austria’s Most Wanted: Twenty-Seven Years and Counting")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor008"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/TheBestNewTrueCrimeStories10#_idTextAnchor052"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link1"
  }, [_c('a', {
    attrs: {
      "href": "#/TheBestNewTrueCrimeStories10#_idTextAnchor052"
    }
  }, [_vm._v("Iris Reinbacher")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor009"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/TheBestNewTrueCrimeStories11#_idTextAnchor054"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link"
  }, [_c('a', {
    attrs: {
      "href": "#/TheBestNewTrueCrimeStories11#_idTextAnchor054"
    }
  }, [_vm._v("The Curious Case of the Dogs in the Nighttime: "), _c('br'), _vm._v("France’s “Valley of Hell” Mystery")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor010"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/TheBestNewTrueCrimeStories11#_idTextAnchor056"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link1"
  }, [_c('a', {
    attrs: {
      "href": "#/TheBestNewTrueCrimeStories11#_idTextAnchor056"
    }
  }, [_vm._v("Dean Jobb")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor011"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/TheBestNewTrueCrimeStories12#_idTextAnchor058"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link"
  }, [_c('a', {
    attrs: {
      "href": "#/TheBestNewTrueCrimeStories12#_idTextAnchor058"
    }
  }, [_vm._v("A Murder in Beverlywood")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor012"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/TheBestNewTrueCrimeStories12#_idTextAnchor060"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link1"
  }, [_c('a', {
    attrs: {
      "href": "#/TheBestNewTrueCrimeStories12#_idTextAnchor060"
    }
  }, [_vm._v("Priscilla Scott Rhoades")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor013"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/TheBestNewTrueCrimeStories13#_idTextAnchor062"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link"
  }, [_c('a', {
    attrs: {
      "href": "#/TheBestNewTrueCrimeStories13#_idTextAnchor062"
    }
  }, [_vm._v("The Enduring Mystery of Julia Wallace")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor014"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/TheBestNewTrueCrimeStories13#_idTextAnchor064"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link1"
  }, [_c('a', {
    attrs: {
      "href": "#/TheBestNewTrueCrimeStories13#_idTextAnchor064"
    }
  }, [_vm._v("Cathy Pickens")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor015"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/TheBestNewTrueCrimeStories14#_idTextAnchor066"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link"
  }, [_c('a', {
    attrs: {
      "href": "#/TheBestNewTrueCrimeStories14#_idTextAnchor066"
    }
  }, [_vm._v("A Mystery Within the Vatican’s Walls")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor016"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/TheBestNewTrueCrimeStories14#_idTextAnchor068"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link1"
  }, [_c('a', {
    attrs: {
      "href": "#/TheBestNewTrueCrimeStories14#_idTextAnchor068"
    }
  }, [_vm._v("Deirdre Pirro")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor017"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/TheBestNewTrueCrimeStories15#_idTextAnchor070"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link"
  }, [_c('a', {
    attrs: {
      "href": "#/TheBestNewTrueCrimeStories15#_idTextAnchor070"
    }
  }, [_vm._v("In a Field Outside of Edmonton")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor018"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/TheBestNewTrueCrimeStories15#_idTextAnchor072"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link1"
  }, [_c('a', {
    attrs: {
      "href": "#/TheBestNewTrueCrimeStories15#_idTextAnchor072"
    }
  }, [_vm._v("Janel Comeau")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor019"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/TheBestNewTrueCrimeStories16#_idTextAnchor074"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link"
  }, [_c('a', {
    attrs: {
      "href": "#/TheBestNewTrueCrimeStories16#_idTextAnchor074"
    }
  }, [_vm._v("“In Heaven, Everything Is Fine”")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor020"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/TheBestNewTrueCrimeStories16#_idTextAnchor076"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link1"
  }, [_c('a', {
    attrs: {
      "href": "#/TheBestNewTrueCrimeStories16#_idTextAnchor076"
    }
  }, [_vm._v("Mitzi Szereto")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor021"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/TheBestNewTrueCrimeStories17#_idTextAnchor078"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link"
  }, [_c('a', {
    attrs: {
      "href": "#/TheBestNewTrueCrimeStories17#_idTextAnchor078"
    }
  }, [_vm._v("The Railway Child")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor022"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/TheBestNewTrueCrimeStories17#_idTextAnchor080"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link1"
  }, [_c('a', {
    attrs: {
      "href": "#/TheBestNewTrueCrimeStories17#_idTextAnchor080"
    }
  }, [_vm._v("C L Raven")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor023"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/TheBestNewTrueCrimeStories18#_idTextAnchor085"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link"
  }, [_c('a', {
    attrs: {
      "href": "#/TheBestNewTrueCrimeStories18#_idTextAnchor085"
    }
  }, [_vm._v("Swallowed Up by the Dark: The Vanishing of "), _c('br'), _vm._v("Benjamin Bathurst")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor024"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/TheBestNewTrueCrimeStories18#_idTextAnchor087"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link1"
  }, [_c('a', {
    attrs: {
      "href": "#/TheBestNewTrueCrimeStories18#_idTextAnchor087"
    }
  }, [_vm._v("Ciaran Conliffe")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor025"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/TheBestNewTrueCrimeStories19#_idTextAnchor090"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link"
  }, [_c('a', {
    attrs: {
      "href": "#/TheBestNewTrueCrimeStories19#_idTextAnchor090"
    }
  }, [_vm._v("When Boston Turns Its Back")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor026"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/TheBestNewTrueCrimeStories19#_idTextAnchor092"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link1"
  }, [_c('a', {
    attrs: {
      "href": "#/TheBestNewTrueCrimeStories19#_idTextAnchor092"
    }
  }, [_vm._v("Pamela Costello")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor027"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/TheBestNewTrueCrimeStories20#_idTextAnchor094"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link"
  }, [_c('a', {
    attrs: {
      "href": "#/TheBestNewTrueCrimeStories20#_idTextAnchor094"
    }
  }, [_vm._v("Neighbors at War: The Disappearance of John Favara")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor028"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/TheBestNewTrueCrimeStories20#_idTextAnchor096"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link1"
  }, [_c('a', {
    attrs: {
      "href": "#/TheBestNewTrueCrimeStories20#_idTextAnchor096"
    }
  }, [_vm._v("David Breakspear")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor029"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/TheBestNewTrueCrimeStories21#_idTextAnchor099"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link"
  }, [_c('a', {
    attrs: {
      "href": "#/TheBestNewTrueCrimeStories21#_idTextAnchor099"
    }
  }, [_vm._v("The Pype Hayes Murders")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor030"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/TheBestNewTrueCrimeStories21#_idTextAnchor101"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link1"
  }, [_c('a', {
    attrs: {
      "href": "#/TheBestNewTrueCrimeStories21#_idTextAnchor101"
    }
  }, [_vm._v("Paul Williams")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor031"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/TheBestNewTrueCrimeStories22#_idTextAnchor103"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link"
  }, [_c('a', {
    attrs: {
      "href": "#/TheBestNewTrueCrimeStories22#_idTextAnchor103"
    }
  }, [_vm._v("About the Editor")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor032"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/TheBestNewTrueCrimeStories23#_idTextAnchor105"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link"
  }, [_c('a', {
    attrs: {
      "href": "#/TheBestNewTrueCrimeStories23#_idTextAnchor105"
    }
  }, [_vm._v("About the Contributors")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor033"
    }
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3239274e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/TheBestNewTrueCrimeStories-5.vue
// module id = 72
// module chunks = 0